import React, { FC } from 'react';
import { Redirect } from 'react-router';
import { I18nRoutes } from '../../../config/clientRoutes/types';

type Props = {
  routes: I18nRoutes;
};

const LoggedOutFallBackPage: FC<Props> = ({ routes }) => <Redirect to={routes.login} />;

export default LoggedOutFallBackPage;
